/**
 * Created by hanyong.zheng on 2018/12/26.
 */
import request from '@/utils/request'
export function addRepair (object) {
  const data = object
  return request({
    url: '/addRepair',
    method: 'post',
    data
  })
}

export function checkRepair (object) {
  const data = object
  return request({
    url: '/checkRepair',
    method: 'post',
    data
  })
}

export function getRepairList (userId) {
  const data = {
    'userId': userId
  }
  return request({
    url: '/getRepairList',
    method: 'post',
    data
  })
}

export function getBreakDeviceType(object) {
  const data = object;
  return request({
    url: '/getBreakDeviceType',
    method: "post",
    data
  })
}

export function getBreakType(object) { 
  const data = object;
  return request({
    url: "/getBreakType",
    method: "post",
    data
  })
}

export function getRepairInfo (repairParams) {
  const data = {
    'repairId': repairParams.id,
    'userId': repairParams.userId
  }
  return request({
    url: '/getRepairInfo',
    method: 'post',
    data
  })
}

export function getServerModel (deviceSeq) {
  const data = {
    'deviceSeq': deviceSeq
  }
  return request({
    url: '/getServerModel',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/repair.js